import React from 'react';
import AreaTitle from '../AreaTitle';
import ComparisonGraph from '../ComparisonGraph';
import CalculatePayments from "../calculation/Calculation.js";
import FundingProsAndCons from '../FundingProsAndCons';
import UpdateParentWindow from "../update-parent-window/Updater.js";

class Comparison extends React.Component {
  constructor(props) {
    super(props);
    this.animToggleTimer = [];
    this.toggleAnimDuration = 250;
    this.selectedFundingModels = [];
    this.state = {
      curTab: null,
      toggling: false
    };
  }

  componentDidMount() {
    this.props.updateState({
      phase: 3
    });
  }

  toggleSection(e, key) {
    e.stopPropagation();
    if(this.animToggleTimer[key]) clearTimeout(this.animToggleTimer[key]);
    (this.state.curTab === key) ? this.setState({curTab: null}) : this.setState({curTab: key});
    setTimeout(() => {
        this.setState({toggling: true});
    },20);
    this.animToggleTimer[key] = setTimeout(() => {
      this.setState({toggling: false});
      UpdateParentWindow(this.props.state, this.props.selectImplementationModel);
      clearTimeout(this.animToggleTimer[key]);
    }, this.toggleAnimDuration);
  }

  renderProsAndCons() {
    let prosAndCons = [];
    this.selectedFundingModels.forEach((item,index) => {
      prosAndCons.push(<div className="pros-and-cons-block" key={"pros-and-cons-"+item.slug}>
        <div className="pros-and-cons-title">
          {item.title}
          {item.link ? <a href={item.link} target={item.slug}>Lue lisää</a> : null}
        </div>
        <FundingProsAndCons benefits={item.benefits} disadvantages={item.disadvantages}></FundingProsAndCons>
      </div>);
    });
    return prosAndCons;
  }

  renderSelectedModels() {
    let curFundModels = [];
    this.selectedFundingModels.forEach((item,index) => {
      let state = this.props.state;
      let calc = CalculatePayments(item.slug, item.title, state.investmentSize, state.payBackTime, state.completionYear,
                                   state.varsLoanInterest, state.varsGreenLoanInterest, state.varsLeasingInterest,
                                   state.varsLeasingResidualValue, state.varsGreenLeasingInterest,
                                   state.varsGreenLeasingResidualValue, state.varsLongRentInitialRent,
                                   state.varsLongRentIndexing, state.varsLongRentRedemptionValue,
                                   state.varsShortRentInitialRent, state.varsShortRentIndexing,
                                   state.varsShortRentRedemptionValue, state.varsLeasingContractTime,
                                   state.varsGreenLeasingContractTime);

      curFundModels.push(
        <div className="fund-model-item"
             key={"comp-fund-model-"+item.slug}>
          <div className="col-left">
            <h3>{item.title}</h3>
            <span className="description">{item.description}</span>
          </div>
          <div className="col-right">
            <div>
              Pääomakustannukset
              <span className="price">
                {calc.sum.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1 ")} €
              </span>
            </div>
          </div>
        </div>
      );
    });
    return (<div className="card-wrapper selected-models">
      <div className="funding-model-and-price">
        {curFundModels}
      </div>
    </div>);
  }

  render() {
    this.selectedFundingModels = this.props.state.fundingModels.filter((item) => {
      if(this.props.state.selectedFundings.includes(item.slug)) return item;
      return null;
    }).sort((a, b) => a.order - b.order);
    let state = this.props.state;
    let graphs = this.selectedFundingModels
                     .map(m => CalculatePayments(m.slug, m.title, state.investmentSize, state.payBackTime, state.completionYear,
                                                 state.varsLoanInterest, state.varsGreenLoanInterest, state.varsLeasingInterest,
                                                 state.varsLeasingResidualValue, state.varsGreenLeasingInterest,
                                                 state.varsGreenLeasingResidualValue, state.varsLongRentInitialRent,
                                                 state.varsLongRentIndexing, state.varsLongRentRedemptionValue,
                                                 state.varsShortRentInitialRent, state.varsShortRentIndexing,
                                                 state.varsShortRentRedemptionValue, state.varsLeasingContractTime,
                                                 state.varsGreenLeasingContractTime));

    let curImpModel = this.props.state.implementationModels.filter((item) => {
      if(item.slug === this.props.state.implementationModel) return item;
      return null;
    });

    return (
      <div className="view-content">
        <AreaTitle text="Vertailu"/>
        {this.renderSelectedModels()}
        <div className="card-wrapper comparison-graph">
          <ComparisonGraph graphData={graphs}/>
        </div>
        <div className="card-wrapper">
          <div className="card not-selectable">
            <h3>Toteutustapa: {curImpModel[0].title}</h3>
            {curImpModel[0].description}
            <div className="card-tabs">
              {curImpModel[0].use_cases ?
                <div className={"card-tab" +
                  (this.state.curTab === 'use-cases' ? " card-tab--active" : "")}
                  onClick={(e) => {this.toggleSection(e, 'use-cases')}}>
                    Käyttökohteet
                </div>
                : null
              }
              {curImpModel[0].benefits_and_risks ?
                <div className={"card-tab" +
                  (this.state.curTab === 'risks' ? " card-tab--active" : "")}
                  onClick={(e) => {this.toggleSection(e, 'risks')}}>
                    Ominaisuudet
                </div>
                : null
              }
            </div>
          </div>
          {curImpModel[0].use_cases ?
            <div className={"card-tab-content" +
                (this.state.curTab === 'use-cases' ? " card-tab-content--open" : "") +
                (this.state.toggling ? " card-tab-content--toggling" : "")}
                style={{transitionDuration: this.toggleAnimDuration + "ms"}}
                dangerouslySetInnerHTML={{ __html: curImpModel[0].use_cases }}>
            </div>
            :null}
          {curImpModel[0].benefits_and_risks ?
            <div className={"card-tab-content card-tab-content--img" +
                (this.state.curTab === 'risks' ? " card-tab-content--open" : "") +
                (this.state.toggling ? " card-tab-content--toggling" : "")}
                style={{transitionDuration: this.toggleAnimDuration + "ms"}}>
              <img src={curImpModel[0].benefits_and_risks} alt="Ominaisuudet taulukko"
                   onClick={(e) => {
                     e.persist();
                     this.props.updateState({imageZoom:{img:curImpModel[0].benefits_and_risks,e:e}})}
              } />
            </div>
            :null}
        </div>
        <div className="card-wrapper card-content">
          <h3>{this.props.state.selectedFundings.length > 1 ? "Rahoitusmallien" : "Rahoitusmallin"} ominaisuudet</h3>
          {this.renderProsAndCons()}
        </div>
      </div>
    );
  }
}

export default Comparison;
